import { render, staticRenderFns } from "./FinanceInvoiceWidgetTableItem.vue?vue&type=template&id=9b2ef0d6&"
import script from "./FinanceInvoiceWidgetTableItem.vue?vue&type=script&lang=js&"
export * from "./FinanceInvoiceWidgetTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports